"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "andora": {
    "780e42a7": [{
      "hkey": "7a67fda1",
      "slug": "rollo-via-del-poggio",
      "name": "Rollo-Via del Poggio",
      "primary": true,
      "skipSearch": false
    }],
    "rollo": [{
      "hkey": "7a67fda1",
      "slug": "rollo-via-del-poggio",
      "name": "Rollo-Via del Poggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8f2b161f": [{
      "hkey": "0117c08e",
      "slug": "san-bartolomeo-pian-rosso",
      "name": "San Bartolomeo-Pian Rosso",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolomeo": [{
      "hkey": "0117c08e",
      "slug": "san-bartolomeo-pian-rosso",
      "name": "San Bartolomeo-Pian Rosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eab87732": [{
      "hkey": "0117c08e",
      "slug": "san-bartolomeo-pian-rosso",
      "name": "San Bartolomeo-Pian Rosso",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro": [{
      "hkey": "0117c08e",
      "slug": "san-bartolomeo-pian-rosso",
      "name": "San Bartolomeo-Pian Rosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "andora"
    }]
  }
};
exports["default"] = _default;